var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "{className}",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "currentColor",
    fillOpacity: 0.2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4003 19.3399L28.6603 16.5999C28.3027 16.264 27.8341 16.0712 27.3436 16.0583C26.8532 16.0454 26.3751 16.2132 26.0003 16.5299L17.0003 25.5299C16.6771 25.8558 16.4758 26.2831 16.4303 26.7399L16.0003 30.9099C15.9868 31.0563 16.0058 31.204 16.056 31.3422C16.1061 31.4805 16.1861 31.606 16.2903 31.7099C16.3837 31.8025 16.4946 31.8759 16.6164 31.9256C16.7382 31.9754 16.8687 32.0006 17.0003 31.9999H17.0903L21.2603 31.6199C21.7171 31.5744 22.1443 31.3731 22.4703 31.0499L31.4703 22.0499C31.8196 21.6808 32.0084 21.1884 31.9953 20.6804C31.9822 20.1724 31.7682 19.6904 31.4003 19.3399ZM21.0803 29.6199L18.0803 29.8999L18.3503 26.8999L24.0003 21.3199L26.7003 24.0199L21.0803 29.6199ZM28.0003 22.6799L25.3203 19.9999L27.2703 17.9999L30.0003 20.7299L28.0003 22.6799Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e07fb19e13fc312cf0ae8ea28f8fd44f.svg";
export { ForwardRef as ReactComponent };